export default "__VITE_ASSET__BTfuEkSu__"